
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import AddModel from './add-model.vue'
  @Component({ 
    components: {
      AddModel
    } 
  })
export default class AddStorage extends Vue {
    @Prop() storage: boolean
    @Prop() isAddType: string
    @Prop() goodsItem: any
    @Prop() optionList: any

    storages: any = {
      goods_type_id: '',
      brand: '',
      unit: '',
      is_enabled: 1,
      campus_id: '',
      remark: ''
    }
    format: any = {
      model_number: '',
      total: '',
      price: ''
    }
    dialogModel: boolean = false
    goods_info: any = []
    goodsCampus: any = []
    goodsTypeId: any = []
    p_hight: any = window.innerHeight - 150 + 'px'
    modelType: string = 'add'
    goods_info_list: any = []
    addModelId: number = 0
    goodsBrand: any = []
    restaurants:any = []


    @Watch('storage') 
    getStorage(newVal, oldVal) {
      this.getGoodsBandList()
      if (newVal) {
        if(this.isAddType === 'edit') {
          this.storages = {
            goods_type_id: this.goodsItem.goods_type_id,
            brand: this.goodsItem.brand,
            unit: this.goodsItem.unit,
            is_enabled: this.goodsItem.is_enabled,
            campus_id: this.goodsItem.campus_id,
            remark: this.goodsItem.remark
          }
          this.goods_info = this.goodsItem.goods_info
          this.goodsCampus = this.optionList.campus_id
          this.goodsTypeId = this.optionList.goods_type_id
        } else {
          this.goodsTypeId = []
          this.goodsCampus = []
          if(this.optionList.campus_id) {
            for(var i = 0; i < this.optionList.campus_id.length; i++) {
              if(this.optionList.campus_id[i].is_enabled === 1) {
                this.goodsCampus.push(this.optionList.campus_id[i])
              }
              if(this.optionList.goods_type_id[i].is_enabled === 1) {
                this.goodsTypeId.push(this.optionList.goods_type_id[i])
              }
            }
          }
        }
      }
    }

    changeEnable(val) {
      this.storages.is_enabled = val
    }
    // 判断是规格否可删除
    compareModel(val, list) {
      let index = list.findIndex((item)=> {
        return item.addModelId === val
      })
      return index
    }

    async deleteModelList(val){
      const flag = this.compareModel(val.addModelId, this.goods_info)
      this.goods_info.splice(flag, 1)
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
    }

    deleteModel(val) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteModelList(val)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        })
      })
    }
    async getGoodsBandList() {
      const res: any = await CourseModule.getGoodsBand()
      this.restaurants = []
      if(res.data && res.data.length > 0) {
        for (var i = 0; i < res.data.length; i++) {
          this.restaurants.push({value: res.data[i].brand})
        }
      }
    }
    addModelDialog() {
      this.addModelId++
      this.format = {
        addModelId: this.addModelId,
        model_number: '',
        total: '',
        price: ''
      }
      this.goods_info.push({
        addModelId: this.addModelId,
        model_number: '',
        total: '',
        price: ''
      })

      // this.modelType = 'add'
      // this.dialogModel = true
    }
    editModel(val) {
      this.format = {
        addModelId: val.addModelId,
        model_number: val.model_number,
        total: val.total,
        price: val.price
      }
      this.modelType = 'edit'
      this.dialogModel = true
    }   
    addModelClose(res) {
      if(res.type) {
        if (this.modelType === 'add') {
          this.goods_info.push(res.val)
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
        } else {
          for (var i = 0; i < this.goods_info.length; i++) {
            if(this.goods_info[i].addModelId === res.val.addModelId) {
              this.goods_info[i].price = res.val.price
              this.goods_info[i].model_number = res.val.model_number
              this.$message({
                type: 'success',
                message: '编辑成功!'
              })
            }
          }
        }
      }
      this.dialogModel = false
    }
    close() {
      this.$emit('add-storage', { type: false })
      this.refeshStorage()
    }
    refeshStorage() {
      this.format = {
        model_number: '',
        total: '',
        price: ''
      }
      this.goods_info = []
      this.storages = {
        goods_type_id: '',
        brand: '',
        unit: '',
        is_enabled: 1,
        campus_id: '',
        remark: ''
      }
    }
    async addGoods() {
      for(var i = 0; i < this.goods_info.length; i++) {
        delete this.goods_info[i].addModelId
      }
      this.storages['goods_info'] = this.goods_info
      const res: any = await CourseModule.addGoods(this.storages)
      if(res.code === 200) {
         this.$message({
            type: 'success',
            message: '添加成功!'
          })
          this.$emit('add-storage', { type: true })
          this.refeshStorage()
      } else {
          this.$message.error('添加失败')
          this.refeshStorage()
      }
    }
    async editGoods() {
      for(var i = 0; i < this.goods_info.length; i++) {
        delete this.goods_info[i].addModelId
      }
      this.storages['goods_info'] = this.goods_info
      this.storages['id'] = this.goodsItem.id
      const res: any = await CourseModule.editGoods(this.storages)
      if(res.code === 200) {
         this.$message({
            type: 'success',
            message: '编辑成功!'
          })
          this.$emit('add-storage', { type: true })
          this.refeshStorage()
      } else {
          this.$message.error('编辑失败')
          this.refeshStorage()
      }
    }
    submit() {
      if(this.isAddType === 'add') {
        this.addGoods()
      } else {
        this.editGoods()
      }
    }
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results)
    }
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      }
    }
    handleSelect(item) {
      console.log(item)
    }

    mounted() {
     
    }
}
